export const sourceTypeList = [
    {
        label: '电子证据平台',
        value: 955740
    },
    {
        label: '权利卫士App',
        name: '权利卫士App',
        value: 954210
    },
    {
        label: '知识产权保护平台',
        value: 952310
    },
    {
        label: '电子邮件认证平台',
        value: 700025
    },
    {
        label: 'AIGC PAS',
        value: 700028
    }
]

export const sourceTypeForFilterList = [
    ...sourceTypeList,
    {
        label: '软著保护平台',
        value: 700023
    }
]

export const sourceTypeFilter = (value) => {
    const obj = sourceTypeForFilterList.find(item => item.value === value)
    return obj ? obj.label : '-'
}